var React = require('react');

function ArrowBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m9.3 20.925-8.325-8.3Q.85 12.5.788 12.337.725 12.175.725 12q0-.175.063-.338.062-.162.187-.287L9.3 3.05q.3-.3.7-.3.4 0 .725.325.3.275.3.687 0 .413-.3.713L3.175 12l7.55 7.55q.275.275.275.675t-.3.7q-.3.3-.7.3-.4 0-.7-.3Z"}));
}

ArrowBack.defaultProps = {"viewBox":"0 0 12 24"};

module.exports = ArrowBack;

ArrowBack.default = ArrowBack;
